import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled,
  ColStyled,
  LinkStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-life-and-money';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-life-and-money-${baseIdSuffix}`}
        linkUrl='/life-and-money/'
        variant='primaryDeemphasize'>
        Life &#38; Money
      </Link>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-financial-planning-${baseIdSuffix}`}
          linkUrl='/life-and-money/financial-planning/'
          variant='primaryDeemphasize'>
          Financial Planning
        </LinkStyled>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-your-financial-plan-${baseIdSuffix}`}
                  linkUrl='/life-and-money/financial-planning/your-financial-plan/'
                  variant='primaryDeemphasize'>
                  Your Financial Plan
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-your-retirement-${baseIdSuffix}`}
                  linkUrl='/life-and-money/financial-planning/your-retirement/'
                  variant='primaryDeemphasize'>
                  Your Retirement
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-your-taxes-${baseIdSuffix}`}
                  linkUrl='/life-and-money/financial-planning/your-taxes/'
                  variant='primaryDeemphasize'>
                  Your Taxes
                </Link>
              ),
            },
            {
              bulletText: (
                <LinkStyled
                  id={`${baseIdPrefix}-your-dreams-${baseIdSuffix}`}
                  linkUrl='/life-and-money/financial-planning/your-dreams/'
                  variant='primaryDeemphasize'>
                  Your Dreams
                </LinkStyled>
              ),
            },
          ]}
        />
      </>
    ),
  },
  {
    bulletText: (<>
      <LinkStyled
        id={`${baseIdPrefix}-investing-${baseIdSuffix}`}
        linkUrl='/life-and-money/investing/'
        variant='primaryDeemphasize'>
        Investing
      </LinkStyled>
      <BulletedList
        bulletedListData={[
          {
            bulletText: (
              <Link
                id={`${baseIdPrefix}-starting-to-invest-${baseIdSuffix}`}
                linkUrl='/life-and-money/investing/starting-to-invest/'
                variant='primaryDeemphasize'>
                Starting to Invest
              </Link>
            ),
          },
          {
            bulletText: (
              <Link
                id={`${baseIdPrefix}-growing-wealth-${baseIdSuffix}`}
                linkUrl='/life-and-money/investing/growing-wealth/'
                variant='primaryDeemphasize'>
                Growing Wealth
              </Link>
            ),
          },
          {
            bulletText: (
              <Link
                id={`${baseIdPrefix}-insurance-${baseIdSuffix}`}
                linkUrl='/life-and-money/insurance/'
                variant='primaryDeemphasize'>
                Insurance
              </Link>
            ),
          },
          {
            bulletText: (
              <Link
                id={`${baseIdPrefix}-disability-insurance-${baseIdSuffix}`}
                linkUrl='/life-and-money/insurance/disability-insurance/'
                variant='primaryDeemphasize'>
                Disability Insurance
              </Link>
            ),
          },
          {
            bulletText: (
              <LinkStyled
                id={`${baseIdPrefix}-life-insurance-${baseIdSuffix}`}
                linkUrl='/life-and-money/insurance/life-insurance/'
                variant='primaryDeemphasize'>
                Life Insurance
              </LinkStyled>
            ),
          },
        ]}
        bulletType='filledCircle'
      />
    </>),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-everyday-money-${baseIdSuffix}`}
          linkUrl='/life-and-money/everyday-money/'
          variant='primaryDeemphasize'>
          Everyday Money
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-managing-debt-${baseIdSuffix}`}
                  linkUrl='/life-and-money/everyday-money/managing-debt/'
                  variant='primaryDeemphasize'>
                  Managing Debt
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-managing-finances-${baseIdSuffix}`}
                  linkUrl='/life-and-money/everyday-money/managing-finances/'
                  variant='primaryDeemphasize'>
                  Managing Finances
                </Link>
              ),
            },
            {
              bulletText: (
                <LinkStyled
                  id={`${baseIdPrefix}-building-savings-${baseIdSuffix}`}
                  linkUrl='/life-and-money/everyday-money/building-savings/'
                  variant='primaryDeemphasize'>
                  Building Savings
                </LinkStyled>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-family-and-work-${baseIdSuffix}`}
          linkUrl='/life-and-money/family-and-work/'
          variant='primaryDeemphasize'>
          Family &#38; Work
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-your-business-${baseIdSuffix}`}
                  linkUrl='/life-and-money/family-and-work/your-business/'
                  variant='primaryDeemphasize'>
                  Your Business
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-your-home-${baseIdSuffix}`}
                  linkUrl='/life-and-money/family-and-work/your-home/'
                  variant='primaryDeemphasize'>
                  Your Home
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-your-family-${baseIdSuffix}`}
                  linkUrl='/life-and-money/family-and-work/your-family/'
                  variant='primaryDeemphasize'>
                  Your Family
                </Link>
              ),
            },
            {
              bulletText: (
                <LinkStyled
                  id={`${baseIdPrefix}-your-career-${baseIdSuffix}`}
                  linkUrl='/life-and-money/family-and-work/your-career/'
                  variant='primaryDeemphasize'>
                  Your Career
                </LinkStyled>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-market-commentary-${baseIdSuffix}`}
          linkUrl='/life-and-money/market-commentary/'
          variant='primaryDeemphasize'>
          Market Commentary
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-weekly-market-commentary-${baseIdSuffix}`}
                  linkUrl='/life-and-money/market-commentary/weekly-market-commentary/'
                  variant='primaryDeemphasize'>
                  Weekly Market Commentary
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-market-insights-${baseIdSuffix}`}
                  linkUrl='/life-and-money/market-commentary/market-insights/'
                  variant='primaryDeemphasize'>
                  Market Insights
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-asset-allocation-${baseIdSuffix}`}
                  linkUrl='/life-and-money/market-commentary/asset-allocation/'
                  variant='primaryDeemphasize'>
                  Asset Allocation
                </Link>
              ),
            },
            {
              bulletText: (
                <LinkStyled
                  id={`${baseIdPrefix}-quarterly-market-commentar-${baseIdSuffix}`}
                  linkUrl='/life-and-money/market-commentary/quarterly-market-commentary/'
                  variant='primaryDeemphasize'>
                  Quarterly Market Commentary
                </LinkStyled>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
];

export default () => (
  <ColStyled
    medium={6}
    id='sitemap-life-and-money-list'>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      Life &#38; Money
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'/>
  </ColStyled>
);
